import { render, staticRenderFns } from "./files-app.vue?vue&type=template&id=35de6dcd&"
import script from "./files-app.vue?vue&type=script&lang=ts&"
export * from "./files-app.vue?vue&type=script&lang=ts&"
import style0 from "./files-app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports